export default __webpack_public_path__ + "static/media/img_backend.2d5fa02e.jpg";